import React from 'react';
import { NativeWindStyleSheet } from 'nativewind';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { Provider } from 'react-redux';
import Store from './src/redux/store/store';
import AuthProvider from './src/auth/AuthProvider';
import Navigation from './src/navigation/Navigation';
import { Notification } from './src/components/Notification';
import GuestNavigation from './src/navigation/GuestNavigation';
import RouteConstants from './src/constants/RouteConstants';

NativeWindStyleSheet.setOutput({
  default: 'native',
});

const App = () => {
  const isGuest =
    false ||
    globalThis.location.pathname === `/${RouteConstants.guestpayments}` ||
    sessionStorage.getItem('pncCallbackRole') === 'guest';

  const AppNavigation = () => {
    /*
     * CLEAR COMMENTS AFTER IMPLEMENTATION
     *
     * Use Cases Shall Be As Belows:
     *
     * isGuest boolean value shall be false by default
     *
     * isGuest boolean only turns true in case guest-payments is opened or guest cookie/token exists
     *
     * IN CASE OKTA USER IS LOGGED IN AFTER ACTIVE GUEST SESSION, isGuest SHALL BE RETURN FALSE AND GUEST CREDENTIALS SHALL BE CLEARED FROM STORAGE
     *
     * IN CASE OKTA SESSION EXISTS AND A USER LOGS IN TO GUEST, CLEAR OKTA SESSION CREDENTIALS (sid cookie and tokens)
     *
     */

    return isGuest ? <GuestNavigation /> : <Navigation />;
  };

  return (
    <SafeAreaProvider>
      <AuthProvider>
        <Provider store={Store}>
          <Notification isGuest={isGuest} />
          <AppNavigation />
        </Provider>
      </AuthProvider>
    </SafeAreaProvider>
  );
};

export default App;
